import "./table.css";

const SimpleTable = ({ data = [], rowTitle, caption }) => {
  if (!Array.isArray(data) || data.length === 0 || !Array.isArray(data[0])) {
    return null;
  }

  const rowHeaders = data[0].slice(1);
  const results = data.slice(1);

  return (
    <table className="custom-table">
      <caption>{caption}</caption>
      <thead>
        <tr>
          <th scope="col">{rowTitle}</th>
          {rowHeaders.map((header, key) => (
            <th key={`header-${key}`} scope="col">
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {results.map((result, key) => (
          <tr key={`row-${key}`}>
            {result.map((item, idx) =>
              idx === 0 ? (
                <th key={`item-${idx}`} scope="row">
                  {item}
                </th>
              ) : (
                <td key={`item-${idx}`}>{item}</td>
              )
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SimpleTable;
